import { FunnelBadge } from '../shared/FunnelBadge'
import { StatusIndicator } from '../shared/StatusIndicator'
import { CountryFlag } from '../shared/CountryFlag'
import type { Funnel } from '../../types'

interface FunnelOverviewProps {
  funnel: Funnel
}

export function FunnelOverview({ funnel }: FunnelOverviewProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(date)
  }

  return (
    <div
      className="rounded-lg border p-4"
      style={{
        borderColor: 'var(--fn-border)',
        backgroundColor: 'var(--fn-bg-card)',
      }}
    >
      <h3 className="text-sm font-semibold mb-3 text-fn-text">
        Funnel Overview
      </h3>

      <div className="space-y-3">
        <div>
          <p className="text-xs mb-1 text-fn-text-muted">
            Status
          </p>
          <StatusIndicator isActive={funnel.isActive} size="sm" />
        </div>

        {funnel.funnelType && (
          <div>
            <p className="text-xs mb-1 text-fn-text-muted">
              Type
            </p>
            <FunnelBadge type="funnel" value={funnel.funnelType} />
          </div>
        )}

        {funnel.trafficType && (
          <div>
            <p className="text-xs mb-1 text-fn-text-muted">
              Traffic Type
            </p>
            <span className="text-sm capitalize text-fn-text">
              {funnel.trafficType}
            </span>
          </div>
        )}

        {funnel.countries && funnel.countries.length > 0 && (
          <div>
            <p className="text-xs mb-1 text-fn-text-muted">
              Countries
            </p>
            <div className="flex flex-wrap gap-1">
              {funnel.countries.map((code) => (
                <CountryFlag key={code} code={code} showLabel={false} />
              ))}
            </div>
          </div>
        )}

        {funnel.productId && (
          <div>
            <p className="text-xs mb-1 text-fn-text-muted">
              Product ID
            </p>
            <span className="text-sm font-mono text-fn-text">
              {funnel.productId}
            </span>
          </div>
        )}

        <div>
          <p className="text-xs mb-1 text-fn-text-muted">
            Priority
          </p>
          <span className="text-sm font-medium text-fn-text">
            {funnel.priority}
          </span>
        </div>

        <div className="pt-2 border-t border-fn-border">
          <p className="text-xs mb-1 text-fn-text-muted">
            Created
          </p>
          <span className="text-xs text-fn-text-sub">
            {formatDate(funnel.createdAt)}
          </span>
        </div>

        <div>
          <p className="text-xs mb-1 text-fn-text-muted">
            Last Updated
          </p>
          <span className="text-xs text-fn-text-sub">
            {formatDate(funnel.updatedAt)}
          </span>
        </div>
      </div>
    </div>
  )
}
